import type { SurveyTarget } from '../surveyTypes';

/**
 * The divisions or positions a survey covers, as one line.
 *
 * **An empty set means ALL** — the survey singled none out — so it reads as the `all` wording
 * rather than an em dash, which would claim the survey has no value. One helper, so the list,
 * the profile header and the details card cannot word it three ways.
 */
export function describeTargets(targets: readonly SurveyTarget[], all: string): string {
  return targets.length === 0 ? all : targets.map((t) => t.name).join(', ');
}
